var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1306.122 1653.832 37.101 34.956",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #2d2d2d;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    className: "cls-1",
    d: "M29.516,24.985H27.84l-.594-.54a12.505,12.505,0,0,0,3.33-8.454C30.577,8.816,24.4,3,16.788,3S3,8.816,3,15.991,9.173,28.982,16.788,28.982a14.231,14.231,0,0,0,8.973-3.138l.573.56v1.579l10.606,9.973L40.1,34.978Zm-12.728,0a9.27,9.27,0,0,1-9.546-8.994A9.27,9.27,0,0,1,16.788,7a9.27,9.27,0,0,1,9.546,8.994A9.27,9.27,0,0,1,16.788,24.985Z",
    transform: "translate(-1309.122 1650.832)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.776323d63ae5d5314c36348548395d75.svg";
export { ForwardRef as ReactComponent };